// extracted by mini-css-extract-plugin
export var ctaWhite = "started-module--ctaWhite--bbf80";
export var goArrow = "started-module--goArrow--7e820";